import type { IconProps } from '../types/IconProps.ts';
export const Crown: IconProps = {
    name: 'Crown',
    children: [
        `<path d="M2.13 5.5a.2.2 0 0 1 .3-.21l5.4 3.6c.09.06.22.02.28-.08l3.72-6.5a.2.2 0 0 1 .34 0l3.72 6.5c.06.1.2.14.29.07l5.39-3.6a.2.2 0 0 1 .3.22L19.2 16.24a1 1 0 0 1-.97.76H5.78a1 1 0 0 1-.97-.76zM5 21h14" />`,
    ]
};